import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[ktToasts]'
})
export class ToastsDirective {
  @Input() toastEvent;
  constructor() { }
  
}
